import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    TextField
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient'

const TaxPage = ({ order }) => {
    const [tax, setTax] = useState({});

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.get(`/users/company_tax/${order.username}`);
                const payload = response.data;
                setTax(payload.data);
            } catch (error) {
                console.error(error);
            }
        }

        order.username && fetchData().catch((error) => {
            console.error('Error fetching tax data:', error);
            toast.error('세금 정보 로드 실패');
        });
    }, [order]);


    useEffect(() => {
        const defaultValues = {
            tax_charge: tax?.tax_charge,
            tax_phone_mobile: tax?.tax_phone_mobile,
            tax_email: tax?.tax_email,
            tax_phone_landline: tax?.tax_phone_landline            
        }
        reset(defaultValues)

    }, [reset, tax]);

    const onSubmit = async (data, e) => {

        const formData = new FormData();
        formData.append('com_code', tax.com_code);
        formData.append('tax_charge', data.tax_charge);
        formData.append('tax_phone_mobile', data.tax_phone_mobile);
        formData.append('tax_email', data.tax_email);
        formData.append('tax_phone_landline', data.tax_phone_landline);
        formData.append('tax_tp', tax.tax_tp || '10');

        try {
            await apiService.post(`/users/company_tax/${order.username}`, formData, {
                headers: { "Content-Type": "application/json" }
            });
            toast.success('수정 되었습니다.');
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Card>
            <CardHeader title='결제 정보' titleTypographyProps={{ variant: 'h6' }} />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} id="taxform">
                    <Grid container spacing={6}>                        
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='tax_charge'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='성함'
                                            id='tax_charge'
                                            onChange={onChange}
                                            placeholder='성함을 입력해주세요'
                                            error={Boolean(errors.tax_charge)}
                                            aria-describedby='validation-async-tax_charge'
                                        />
                                    )}
                                />
                                {errors.tax_charge && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-tax_charge'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='tax_phone_mobile'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='휴대전화'
                                            id='tax_phone_mobile'
                                            onChange={onChange}
                                            placeholder='성함을 입력해주세요'
                                            error={Boolean(errors.tax_phone_mobile)}
                                            aria-describedby='validation-async-tax_phone_mobile'
                                        />
                                    )}
                                />
                                {errors.tax_phone_mobile && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-tax_phone_mobile'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='tax_email'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='이메일'
                                            id='tax_email'
                                            onChange={onChange}
                                            placeholder='이메일을 입력해주세요'
                                            error={Boolean(errors.tax_email)}
                                            aria-describedby='validation-async-tax_email'
                                        />
                                    )}
                                />
                                {errors.tax_email && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-tax_email'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='tax_phone_landline'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='유선전화'
                                            id='tax_phone_landline'
                                            onChange={onChange}
                                            placeholder='유선전화를  입력해주세요'
                                            error={Boolean(errors.tax_phone_landline)}
                                            aria-describedby='validation-async-tax_phone_landline'
                                        />
                                    )}
                                />
                                {errors.tax_phone_landline && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-tax_phone_landline'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        
                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
                            <Button type="submit" form="taxform" variant='contained' sx={{ mr: 4 }}>
                                수정
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default TaxPage
